function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChzCheckmarkYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 110 110"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: 110,
  height: 110,
  rx: 15,
  ry: 15,
  style: {
    fill: "#f6f42e"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 85h12v10H30c-8.3 0-15-6.7-15-15V68h10v12c0 2.8 2.2 5 5 5m-5-55c0-2.8 2.2-5 5-5h12V15H30c-8.3 0-15 6.7-15 15v12h10zm60 50c0 2.8-2.2 5-5 5H68v10h12c8.3 0 15-6.7 15-15V68H85zm-5-65H68v10h12c2.8 0 5 2.2 5 5v12h10V30c0-8.3-6.7-15-15-15m-5.1 23.7L49.1 64.5 34.8 50.2l-7.1 7.1 21.4 21.4L82 45.8z",
  style: {
    fill: "#63666a"
  }
}));
export default SvgChzCheckmarkYellow;